/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LatestExchangeRates
 */
export interface LatestExchangeRates {
    /**
     * 
     * @type {Date}
     * @memberof LatestExchangeRates
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof LatestExchangeRates
     */
    rate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LatestExchangeRates
     */
    currency: number;
}

export function LatestExchangeRatesFromJSON(json: any): LatestExchangeRates {
    return LatestExchangeRatesFromJSONTyped(json, false);
}

export function LatestExchangeRatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatestExchangeRates {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'rate': !exists(json, 'rate') ? undefined : json['rate'],
        'currency': json['currency'],
    };
}

export function LatestExchangeRatesToJSON(value?: LatestExchangeRates | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': (value.date.toISOString()),
        'rate': value.rate,
        'currency': value.currency,
    };
}


